// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"194":"90d5be3e","343":"2acae13f","443":"486868ac","764":"e0f75514"}[chunkId] + ".css";
};